/**
 * Created by han on 1/16/2019.
 */

/* hasAttribute */
;(function(prototype) {
	prototype.hasAttribute = prototype.hasAttribute || function(name) {
			return !!(this.attributes[name] &&
			this.attributes[name].specified);
		}
})(Element.prototype);